module.exports = __webpack_public_path__ + "static/media/documentSearchIconDark.e19aa72d.svg";